import React from 'react';
import { Users, Star, Grid, TrendingUp } from 'lucide-react';
export function StatsSection() {
  return <div className="mb-16" data-id="element-233">
      {/* Trust Header */}
      <div className="text-center mb-8" data-id="element-234">
        <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-2" data-id="element-235">
          Trusted by Shoppers. Chosen by Experts.
        </h2>
        <p className="text-lg text-slate-600" data-id="element-236">
          Verified AI Agents You Can Rely On.
        </p>
      </div>

      {/* Rating Strip - Trustpilot Style */}
      <div className="mb-12 p-4 rounded-xl bg-gradient-to-r from-green-50 to-emerald-50 border-2 border-green-200" data-id="element-237">
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 text-center" data-id="element-238">
          <div className="flex items-center gap-2" data-id="element-239">
            <div className="flex" data-id="element-240">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} size={20} className="fill-green-600 text-green-600" data-id="element-241" />)}
            </div>
            <span className="text-lg font-bold text-green-900" data-id="element-242">4.9/5</span>
          </div>
          <span className="text-slate-600 text-sm" data-id="element-243">
            based on early expert reviews
          </span>
          <div className="hidden sm:block w-px h-6 bg-slate-300" data-id="element-244" />
          <div className="flex flex-wrap items-center justify-center gap-3 text-xs text-slate-700 font-medium" data-id="element-245">
            <span className="flex items-center gap-1" data-id="element-246">
              <span className="w-2 h-2 rounded-full bg-green-600" data-id="element-247" />
              Verified AI Agents
            </span>
            <span className="flex items-center gap-1" data-id="element-248">
              <span className="w-2 h-2 rounded-full bg-blue-600" data-id="element-249" />
              Independent Evaluations
            </span>
            <span className="flex items-center gap-1" data-id="element-250">
              <span className="w-2 h-2 rounded-full bg-purple-600" data-id="element-251" />
              Weekly Updates
            </span>
          </div>
        </div>
      </div>

      {/* Stats Grid */}
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mb-12" data-id="element-252">
        <div className="text-center p-6 rounded-2xl bg-white border border-slate-200 shadow-sm" data-id="element-253">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-purple-100 mb-3" data-id="element-254">
            <Grid size={24} className="text-purple-600" data-id="element-255" />
          </div>
          <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-256">100+</div>
          <div className="text-sm text-slate-600" data-id="element-257">Expert Advisors</div>
        </div>

        <div className="text-center p-6 rounded-2xl bg-white border border-slate-200 shadow-sm" data-id="element-258">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-blue-100 mb-3" data-id="element-259">
            <Users size={24} className="text-blue-600" data-id="element-260" />
          </div>
          <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-261">500K+</div>
          <div className="text-sm text-slate-600" data-id="element-262">Active Users</div>
        </div>

        <div className="text-center p-6 rounded-2xl bg-white border border-slate-200 shadow-sm" data-id="element-263">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-green-100 mb-3" data-id="element-264">
            <TrendingUp size={24} className="text-green-600" data-id="element-265" />
          </div>
          <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-266">20</div>
          <div className="text-sm text-slate-600" data-id="element-267">Categories</div>
        </div>

        <div className="text-center p-6 rounded-2xl bg-white border border-slate-200 shadow-sm" data-id="element-268">
          <div className="inline-flex items-center justify-center w-12 h-12 rounded-xl bg-yellow-100 mb-3" data-id="element-269">
            <Star size={24} className="text-yellow-600" data-id="element-270" />
          </div>
          <div className="text-3xl font-bold text-slate-900 mb-1" data-id="element-271">4.8</div>
          <div className="text-sm text-slate-600" data-id="element-272">Avg Rating</div>
        </div>
      </div>

      {/* Why People Use ShoppingExpert.ai - Trustpilot Card Style */}
      <div className="mb-12" data-id="element-273">
        <h3 className="text-2xl font-bold text-slate-900 mb-6 text-center" data-id="element-274">
          Why People Use ShoppingExpert.ai
        </h3>
        <div className="grid md:grid-cols-3 gap-6" data-id="element-275">
          <div className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-276">
            <div className="flex items-center gap-2 mb-3" data-id="element-277">
              <Star size={20} className="text-green-600 fill-green-600" data-id="element-278" />
              <h4 className="font-bold text-lg text-slate-900" data-id="element-279">
                Verified Agents
              </h4>
            </div>
            <p className="text-slate-700 text-sm" data-id="element-280">
              Every AI advisor listed is manually reviewed by our team.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-281">
            <div className="flex items-center gap-2 mb-3" data-id="element-282">
              <Star size={20} className="text-green-600 fill-green-600" data-id="element-283" />
              <h4 className="font-bold text-lg text-slate-900" data-id="element-284">
                Clear Categories
              </h4>
            </div>
            <p className="text-slate-700 text-sm" data-id="element-285">
              Find the right agent for electronics, coupons, fashion, price
              comparison, and more.
            </p>
          </div>

          <div className="p-6 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition-shadow" data-id="element-286">
            <div className="flex items-center gap-2 mb-3" data-id="element-287">
              <Star size={20} className="text-green-600 fill-green-600" data-id="element-288" />
              <h4 className="font-bold text-lg text-slate-900" data-id="element-289">
                Updated Weekly
              </h4>
            </div>
            <p className="text-slate-700 text-sm" data-id="element-290">
              New AI agents added and evaluated every week to stay current.
            </p>
          </div>
        </div>
      </div>

      {/* Independent. Unbiased. Transparent. - Smaller, No Black Background */}
      <div className="mb-12 p-6 rounded-2xl bg-slate-50 border border-slate-200 text-center" data-id="element-291">
        <h3 className="text-lg font-bold text-slate-900 mb-2" data-id="element-292">
          Independent. Unbiased. Transparent.
        </h3>
        <p className="text-sm font-semibold text-slate-700" data-id="element-293">
          We Don't Rank Agents by Payments. We Rank Them by Performance.
        </p>
      </div>
    </div>;
}